// extracted by mini-css-extract-plugin
export default {"marginContainer":"tz7_bYAB0EFNiMPKKwsT"};